import { createFileRoute } from "@tanstack/react-router";
import DiagnosedDepressionAt80 from "@/pages/articles/DiagnosedDepressionAt80";
export const Route = createFileRoute("/diagnosed-with-depression-at-80")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Diagnosed With Depression At 80 | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression at 80 is treatable at any age. Learn about TMS, SAINT TMS, and depression treatment options for seniors in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Diagnosed With Depression At 80 | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression at 80 is treatable at any age. Learn about TMS, SAINT TMS, and depression treatment options for seniors in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/diagnosed-with-depression-at-80",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/diagnosed-with-depression-at-80",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DiagnosedDepressionAt80 />;
}
